import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/admin/login") {
      document.title = "Admin Login - TDA";
      return;
    }

    if (pathname.startsWith("/admin")) {
      document.title = "Admin - TDA";
      return;
    }

    if (pathname.startsWith("/verify")) {
      document.title = "Verify - TDA";
      return;
    }

    document.title = "TDA";
  }, [pathname]);
}
